/*
interactions tables are parallel to CareSenseSurvey/SurveyCopy
they store the template data, content, and the actual setup of the interaction/survey/event



*/

import InteractionSettings from "../config/InteractionSettings";
import InteractionNode from "./InteractionNode";
import IntervalSet from "../communications/IntervalSet";
import { DatabaseTable, returnID } from "../BaseTable";
import { types } from "../../helpers/Util";
import InteractionNodeInterval from "./InteractionNodeInterval";
import { postgrest_operators, queryTable, runDatabaseFunction } from "../../helpers/HttpHelper";
import store, { AppThunk } from "../../store/Store";
import { navSliceActions } from "../../store/slices/NavSlice";
import { Action, Dispatch } from "redux";
import { initialState, interactionTreeSliceActions } from "../../store/slices/InteractionTreeSlice";
import Interval from "../communications/Interval";
import CommunicationSet from "../communications/CommunicationSet";


class InteractionRaw extends DatabaseTable {
  id: number;
  title: string;
  shared: boolean;
  properties: InteractionSettings;
  modified: Date;

  // This allows us to do typing in js
  static readonly serializableFields = new Map([
    ["id", [types.number]],
    ["title", [types.string]],
    ["shared", [types.boolean]],
    ["properties", [types.object]],
    ["modified", [types.date, types.string]],
  ]);
  static readonly tableName = "Interaction";

  constructor(
    id = -1,
    title = "",
    shared = false,
    properties = new InteractionSettings("blueprint"),
    modified = new Date(),
  ) {
    super();
    this.id = returnID(id);
    this.title = title;
    this.shared = shared;
    this.properties = properties;
    this.modified = modified;
  }
}

class Interaction extends InteractionRaw {
  constructor(...args: any[]) {
    super(...args);
  }

  public static async findByID(interaction_id:number){
    const response = await queryTable('interaction_node', [
      {
        column: "id",
        operator: postgrest_operators.eq,
        value: interaction_id.toString(),
      },
    ]);
    const responseJSON = await response.json();
    return responseJSON;
  }

  public static addNewInteraction = async (
    setID: number | null,
    parentID: number | null,
    type: string, 
    ordinal:number,
    openDrawer = true
  ) => {
    //record that this was called from the main green "add" button
    //update type to pathway
    let mainInsert = false;
    if (type === "main") {
      mainInsert = true;
      type = "pathway";
    }

    if (!mainInsert && type !== "account") {
      // Make sure parentID isn't null if we're adding an interaction to a set
      if (parentID === null) {
        throw new Error(
          "Error while creating new interaction, ParentID is null but interaction beind added to a set",
        );
      }
    }

    const newInteraction = await Interaction.createInstance({
      title: "Enter New Title",
      properties: new InteractionSettings(type),
    }).save();
    console.log(mainInsert)
    console.log(type)

    // if inserting a new root interaction, we DO NOT insert a node
    if (!mainInsert && type !== "account") {
      
      // if interaction successfully inserted, insert the node
      //console.log(props.ordinal );
      const submittedOrdinal = !ordinal || ordinal === 0 ? 1 : ordinal + 1 
      // console.log(submittedOrdinal);
      const newInteractionNode = await InteractionNode.createInstance({
        id: -1,
        set_interaction_id : setID ?? newInteraction.id,
        parent_interaction_id: parentID as number,
        ordinal: submittedOrdinal,
        child_interaction_id: newInteraction.id,
        condition_id: null,
        modified: new Date(),
      }).save();

      const params = {
        nodeid: newInteractionNode.id,
        parentid: parentID,
        old_ordinal: submittedOrdinal,
        new_ordinal: submittedOrdinal
      };
  
      const dbFunc = "update_ordinality_by_parent";
      try {
        await runDatabaseFunction(dbFunc, params)
      } catch (err: any) {
        console.error("Error with update_ordinality_by_parent: " + err);
      }

      InteractionNode.updateInteractionNodeOrdinalityByParentAndNode(
        newInteractionNode.id,
        newInteractionNode.parent_interaction_id ,
        newInteractionNode.ordinal,
        newInteractionNode.ordinal, 
        false
      )
    }
    // open edit interactions panel to this here interaction
    if(openDrawer){
      store.dispatch(
        navSliceActions.openRightDrawer({
          content: newInteraction,
          type: "interactions",
        }),
      );
    }

    return newInteraction;

  };

  public static async addInteractionToTree(
    setID: number,
    parentID: number,
    type: string,
    ordinal?: number,
  ) {
    //const submittedOrdinal = ordinal ? ordinal : 1;
    const submittedOrdinal = !ordinal || ordinal === 0 ? 1 : ordinal + 1 

    let interval_set_id = null;
    if (type === "interval_set") {
      const interval_set = await IntervalSet.createInstance({
        name: null,
      }).save();
      interval_set_id = interval_set.id;
    }

    const properties = new InteractionSettings(type);
    if (interval_set_id !== null) {
      properties.intervalSetID = interval_set_id;
    }

    const newInteraction = await Interaction.createInstance({
      title: "Enter New Title",
      properties: properties,
    }).save();

    let newInteractionNode = await InteractionNode.createInstance({
      set_interaction_id : setID,
      parent_interaction_id : parentID,
      ordinal: submittedOrdinal,
      child_interaction_id: newInteraction.id,
    })
    
    newInteractionNode = await newInteractionNode.save();

    const params = {
      nodeid: newInteractionNode.id,
      parentid: parentID,
      old_ordinal: submittedOrdinal,
      new_ordinal: submittedOrdinal
    };

    const dbFunc = "update_ordinality_by_parent";
    try {
      await runDatabaseFunction(dbFunc, params)
    } catch (err: any) {
      console.error("Error with update_ordinality_by_parent: " + err);
    }

    InteractionNode.updateInteractionNodeOrdinalityByParentAndNode(
      newInteractionNode.id,
      newInteractionNode.parent_interaction_id,
      submittedOrdinal,
      submittedOrdinal, 
      false
    )
  }
  

  // create brand new interaction right into intervalSet
  public static async addNewInteractionToIntervalSet(
    associatedIntervals: Array<number>,
    title: string,
    properties: InteractionSettings,
    ordinal: number,
    condition: string | null,
    communication: string,
    parentID?: number | null,
    setID?: number | null,
  ) {
    // db update endpoint takes a comma-delimited string of intervalIDs
    // we need to extract them from associatedIntervals to formulate acceptable request param
    // i.e. '1,2,3'
    let interval_ids = "";
    let counter = 0;
    associatedIntervals.forEach((interval) => {
      counter += 1;
      interval_ids += interval;
      // only add commas if we arent at the end
      if (counter !== associatedIntervals.length) {
        interval_ids += ",";
      }
    });

    let insertedInteraction: Interaction | null = null;
    let insertedInteractionNode: InteractionNode | null = null;
    let insertedInteractionNodeIntervals: Array<InteractionNodeInterval> | null =
      null;
    // call the test.create_new_interaction_matrix_row postgres function to have postgres handle the following:
    // 1. create new interaction in interaction
    // 2. create new interaction_node in interaction_node
    // 3. for each provided interval, create a new interaction_node_interval
    const params = {
      interaction_id: -1,
      thetitle: title,
      // associated_intervals: interval_ids,
      associated_intervals: "", // no checked-off ini's by default
      parent_id: parentID,
      set_id: setID,
      theordinal: ordinal + 1,
      theproperties: properties,
    };

    const dbFunc = "create_new_interaction_matrix_row";
    try {
      runDatabaseFunction(dbFunc, params).then(async (data: any) => {
        data = await data.text();
        data = JSON.parse(data);

        insertedInteraction = data.interaction;
        insertedInteractionNode = data.interaction_node;
        insertedInteractionNodeIntervals = data.interaction_node_intervals;

        // update local UI state
        // pass in ids inserted into db records so Redux is hydrated with these values
        if (
          insertedInteraction &&
          insertedInteractionNode &&
          insertedInteractionNodeIntervals
        ) {
          const returnedInteraction = await Interaction.fromJSON(
            insertedInteraction,
          );
          const returnedInteractionNode = await InteractionNode.fromJSON(
            insertedInteractionNode,
          );
          insertedInteractionNodeIntervals.forEach(
            (interactionNodeInterval: InteractionNodeInterval) => {
              InteractionNodeInterval.fromJSON(interactionNodeInterval);
            },
          );

          // open edit interactions panel to this here interaction
          store.dispatch(
            navSliceActions.openRightDrawer({
              content: returnedInteraction,
              type: "interactions",
              extraData: { interactionNode: returnedInteractionNode },
            }),
          );
        }
      });
    } catch (err: any) {
      console.error("Error with adding interaction to interval set: " + err);
    }
  }

  // REPLACES PREVIOUSLY-USED ASYNC ACTION CREATOR THUNK
  // GET ALL INTERACTIONS FOR SETID/PARENTID + UPDATE REDUX STATE
  // THIS IS USED IN BREADCRUMBS, INTERACTION SEARCH, AND OUTCOMES.
  // (ALTHOUGH, THE ONE IN INTERACTION SEARCH WORKS A LITTLE DIFFERENT, SO MAYBE WE HAVE TWO? OR MERGE THEM)
  // calls get_data_for_set()  in postgres db to get everything we need for rendering a structured set of interactions with intervals.
  // - Interactions
  // - Interaction Nodes
  // - Interaction Node Intervals
  // - Intervals
  // - Interval Sets
  // - Interaction Parent Interval
  // ***OR if we are loading in a given set, it often might contain children which are a parent of their entire own set
  // e.g. a pathway within a pathway
  // if we come across such a child, we want to load in all of its data and append to current UI state
  public static fetchAndProcessInteractions = async (
    setID: number,
    append = false,
    parentID: null | number = null,
    updateBreadcrumbs = false,
    directAncestorNode: InteractionNode | null = null, // pass in and add the node directly above this one from
  ) => {

    const interactions: Interaction[] = [];

    let params = {};
    const dbFunc = "get_data_for_set";
    let newRootInteractionID = setID;
    if (parentID) {
      if (directAncestorNode) {
        params = {
          parentid: parentID,
          setid: setID,
          nodeid: directAncestorNode.id,
        };
      } else {
        params = { setid: setID, parentid: parentID };
      }
      newRootInteractionID = parentID; // override newRootInteractionID
    } else {
      if (directAncestorNode) {
        params = { setid: setID, nodeid: directAncestorNode.id };
      } else {
        params = { setid: setID };
      }
    }

    try {
      runDatabaseFunction(dbFunc, params).then(async (data: any) => {
        data = await data.text();
        data = JSON.parse(data);

        if (!append) {
          store.dispatch(interactionTreeSliceActions.replaceState(initialState));
          store.dispatch(
            interactionTreeSliceActions.updateRootInteractionID(
              newRootInteractionID,
            ),
          );
        }

        if (data.interaction_nodes) {
          data.interaction_nodes.forEach((interaction_node: any) =>
            InteractionNode.fromJSON(interaction_node),
          );
        }

        if (data.interactions) {
          data.interactions.forEach((interaction: any) => {
            return Interaction.fromJSON(interaction);
          });
          if (updateBreadcrumbs) {
            // initial breadcrumbs should always be the same as CurrentRootInteractionID
            store.dispatch(navSliceActions.clearBreadcrumbs());

            // initial breadcrumbs should always be the same as CurrentRootInteractionID
            const interactionsObjIndex = interactions.findIndex(
              (interaction: any) => {
                return interaction.id === setID;
              },
            );
            const thisInteraction = interactions[interactionsObjIndex];
            store.dispatch(
              navSliceActions.addToBreadcrumbs({
                currentCrumb: thisInteraction,
              }),
            );
          }
        }

        if (data.intervals) {
          data.intervals.forEach((interval: any) =>
            Interval.fromJSON(interval),
          );
        }

        if (data.interaction_node_intervals) {
          data.interaction_node_intervals.forEach(
            (interaction_node_interval: any) =>
              InteractionNodeInterval.fromJSON(interaction_node_interval),
          );
        }

        if (data.interval_sets) {
          data.interval_sets.forEach((interval_sets: any) =>
            IntervalSet.fromJSON(interval_sets),
          );
        }

        if (data.communication_sets) {
          data.communication_sets.forEach((communication_set: any) =>
            CommunicationSet.fromJSON(communication_set),
          );
        }

        // Everything should be successfully loaded now
        store.dispatch(interactionTreeSliceActions.updateLoaded(true));
        //dispatch(interactionTreeSliceActions.getStateStatus());
      });
    } catch (err: any) {
      console.error("Error with pulling interaction tree " + err);
    }
  };



}

export default Interaction;

// define schema for data returned from create interaction row
export interface CreateNewInteractionMatrixRowReturnProps {
  interaction: Interaction;
  interaction_node: InteractionNode;
  interaction_node_intervals: InteractionNodeInterval[];
}
